import { computed, type ComputedRef } from 'vue';
import type { Options } from 'highcharts';

type AgeBandSeriesData = {
    type: 'area';
    name: string;
    data: number[][];
}[];

type BacklogMetricsSeriesData = ({
    type: 'bar';
    name: string;
    yAxis: string;
    data: number[][];
    color?: string;
    stack?: string;
} | {
    type: 'line';
    name: string;
    yAxis: string;
    color: string;
    stack?: string;
    data: number[][];
})[];

export function useBLOverviewChartConfigs(
    ageBandSeries: ComputedRef<AgeBandSeriesData>,
    backlogMetricsSeries: ComputedRef<BacklogMetricsSeriesData>
) {
    // add `tooltip: SHARED_TOOLTIP_CHART_OPTION,` to chartOption to share tooltip with different series
    const SHARED_TOOLTIP_CHART_OPTION = {
        enabled: true,
        shared: true
    };
    const baseXAxisConfig = {
        type: 'datetime',
        dateTimeLabelFormats: {
            day: '%b  %d %Y',
            month: "%b '%y",
            year: '%Y'
        }
    };

    const ageBandChartOptions = computed(() => ({
        title: { text: '' },
        tooltip: SHARED_TOOLTIP_CHART_OPTION,
        xAxis: baseXAxisConfig,
        yAxis: { title: { text: 'Number of Backlogs' } },
        plotOptions: { series: { stacking: 'normal' } },
        series: ageBandSeries.value,
        credits: { enabled: false }
    } as Partial<Options>));

    const inOutChartOptions = computed(() => ({
        title: { text: '' },
        tooltip: SHARED_TOOLTIP_CHART_OPTION,
        xAxis: baseXAxisConfig,
        yAxis: [
            {
                id: 'yaxis-left',
                allowDecimals: false,
                title: { text: 'Number of Open Workstreams' },
                labels: { style: { color: '#80a3ca' } }
            },
            {
                id: 'yaxis-right',
                allowDecimals: false,
                opposite: true,
                title: { text: 'Total Backlog' },
                labels: { style: { color: '#000000' } }
            }
        ],
        // required for stacking
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: { enabled: false }
            }
        },
        series: backlogMetricsSeries.value,
        credits: { enabled: false }
    } as Partial<Options>));

    return {
        ageBandChartOptions,
        inOutChartOptions
    };
}